import React from 'react';
import { useForm } from 'react-hook-form';
import { SwitchField } from 'components/form';
import { Box, Button, Stack } from '@mui/material';

import { LenderFeatureFlagsPortalConfiguration } from '../types';

interface Props {
  isLoading: boolean;
  defaultValues: LenderFeatureFlagsPortalConfiguration;
  onConfirm: (configuration: LenderFeatureFlagsPortalConfiguration) => Promise<void>;
}

export const FeatureFlagsForm = ({ isLoading, defaultValues, onConfirm }: Props) => {
  const { control, handleSubmit } = useForm<LenderFeatureFlagsPortalConfiguration>({
    defaultValues,
  });

  return (
    <>
      <Stack gap="0.5rem" flex={1}>
        <SwitchField
          control={control}
          name="enableEnhancedBusinessProcessFlows"
          label="Enable Enhanced Business Process Flows"
        />
        <SwitchField control={control} name="subsidyReport" label="Subsidy Report" />
      </Stack>

      <Box>
        <Button loading={isLoading} variant="contained" onClick={handleSubmit(onConfirm)}>
          Save
        </Button>
      </Box>
    </>
  );
};
